import { render, staticRenderFns } from "./OrderLayout.vue?vue&type=template&id=06a55115&scoped=true"
import script from "./OrderLayout.vue?vue&type=script&lang=js"
export * from "./OrderLayout.vue?vue&type=script&lang=js"
import style0 from "./OrderLayout.vue?vue&type=style&index=0&id=06a55115&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a55115",
  null
  
)

export default component.exports